export enum RoomType {
    Direct,
    SupportThread,
}